<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/auycJi/tc-custom/9781504069953.jpg?1704512084615" alt="This image is the cover for the book Tight Lies, The Tom Hunter Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tight Lies, The Tom Hunter Books
      </h1>
      <p class="bookDescription body article font2">
        <b>Behind the refined veneer of professional golf, a sports agent discovers a world of corruption and international criminals: “Hard, fast and really good!” —Lee Child</b><br/><br/>Daniel Ratchet has arrived in Spain, ready to begin his dream job as a golf agent on the professional Tour. Meanwhile, in London, new Tour sponsor Russian Rublex Corporation, with a hidden history of mafia criminality, is pushing through a huge deal with the British government. But things are not what they seem . . .<br/><br/>With the help of Wallace, a cantankerous old golf coach, Daniel discovers match fixing, fraud, and corruption at the heart of the game. A thorn in the Russians’ side, Daniel is kidnapped before he can expose the truth. So Wallace contacts an old army buddy—who deploys loose cannon Tom Hunter on a mission to save him .  .  .<br/><br/>This explosive debut novel is an exhilarating action thriller set in the seductive world of professional sports—against a backdrop of political and corporate corruption in a world of brutal violence.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ted Denton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a066a3e